// -------------------------------------------------------------------
// Rhawn Auto Tag — shared site data
// (Language reframed for Google Ads compliance — we position all
//  vehicle-related work as PAPERWORK ASSISTANCE for our clients,
//  not as direct issuance of restricted government documents.)
// -------------------------------------------------------------------

const commonDocs = [
  "Valid Photo ID or Driver License",
  "Proof of current auto insurance (if applicable)",
  "Payment method (cash, debit, or credit)",
];

export const SITE = {
  name: "Rhawn Auto Tag",
  short: "Rhawn Auto Tag",
  phone: "267-355-0430",
  phoneHref: "tel:+12673550430",
  smsHref: "sms:+12673550430",
  email: "info@rhawntag.com",
  address: "7915 Bustleton Ave, 1st Floor, Philadelphia, PA 19152",
  addressShort: "7915 Bustleton Ave, Philadelphia PA",
  mapsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=7915+Bustleton+Ave+Philadelphia+PA+19152",
  mapsEmbed:
    "https://www.google.com/maps?q=7915+Bustleton+Ave,+Philadelphia,+PA+19152&output=embed",
  hours: [
    { day: "Mon – Sat", time: "9:00 AM – 9:00 PM" },
    { day: "Sunday", time: "12:00 PM – 6:00 PM" },
  ],
  trustBadges: [
    { label: "Trusted Local Provider", icon: "ShieldCheck" },
    { label: "Same-Day Paperwork Help", icon: "Zap" },
    { label: "Walk-Ins Welcome", icon: "DoorOpen" },
    { label: "Multilingual Staff", icon: "Languages" },
    { label: "Licensed & Insured", icon: "BadgeCheck" },
    { label: "5★ Google Rated", icon: "Star" },
  ],
  services: [
    {
      key: "title",
      slug: "title-transfer-assistance",
      name: "Title Transfer Assistance",
      blurb: "We help prepare and organize your Pennsylvania title transfer paperwork — start to finish.",
      icon: "FileCheck2",
      color: "#C5A059",
      longDescription:
        "Our team assists Philadelphia drivers with the paperwork side of Pennsylvania vehicle title transactions — buyer, seller, dealer, or private sale. We review documents, notarize what needs notarizing, and organize your submissions so your paperwork is complete and accurate the first time.",
      benefits: [
        "Paperwork prepared while you wait",
        "In-house notary for eligible signatures",
        "Guidance on required documents",
        "Multilingual paperwork assistance",
      ],
      docs: [
        "Original signed title",
        "Bill of sale (if private transaction)",
        ...commonDocs,
      ],
      metaDescription:
        "Title transfer paperwork assistance in Philadelphia. We help you prepare and organize documents for Pennsylvania vehicle title work. Bustleton Ave.",
    },
    {
      key: "registration",
      slug: "vehicle-paperwork-assistance",
      name: "Vehicle Paperwork Assistance",
      blurb: "Comprehensive help preparing vehicle paperwork for new or existing owners.",
      icon: "CarFront",
      color: "#0A192F",
      longDescription:
        "Bought a car, moved to Pennsylvania, or need help organizing your vehicle paperwork? We assist Philadelphia drivers with preparing the required documents for submission — clearly explained, patiently reviewed, done right the first time.",
      benefits: [
        "Full document review and preparation",
        "Guidance for out-of-state paperwork",
        "Insurance paperwork help if needed",
        "Bilingual, patient service",
      ],
      docs: [
        "Signed title or manufacturer's certificate of origin",
        "Proof of auto insurance",
        ...commonDocs,
      ],
      metaDescription:
        "Vehicle paperwork assistance in Philadelphia. We help you prepare documents for Pennsylvania vehicle records.",
    },
    {
      key: "renewal",
      slug: "renewal-paperwork-assistance",
      name: "Renewal Paperwork Help",
      blurb: "Assistance organizing your annual renewal paperwork.",
      icon: "RefreshCw",
      color: "#B48947",
      longDescription:
        "Whether your renewal is coming up or already expired, our team helps you organize the paperwork and understand next steps. We simplify a process most drivers only deal with once a year.",
      benefits: [
        "Paperwork reviewed on the spot",
        "Clear explanation of options",
        "Evening & weekend hours",
        "Fee schedule shown up front",
      ],
      docs: [
        "Current or previous registration card",
        ...commonDocs,
      ],
      metaDescription:
        "Renewal paperwork assistance in Philadelphia. Same-day help organizing your renewal documents.",
    },
    {
      key: "temp",
      slug: "temporary-tag-paperwork",
      name: "Temporary Tag Paperwork",
      blurb: "Help with the paperwork for temporary tag applications.",
      icon: "Timer",
      color: "#C5A059",
      longDescription:
        "We assist Philadelphia drivers with preparing the documentation needed for a temporary tag application — private-party sales, dealer trades, or out-of-state buyers. Our team reviews everything before submission so nothing gets kicked back.",
      benefits: [
        "Paperwork organized while you wait",
        "Guidance for private-party purchases",
        "Insurance paperwork help",
        "Multilingual staff",
      ],
      docs: [
        "Signed title or bill of sale",
        "Proof of insurance",
        ...commonDocs,
      ],
      metaDescription:
        "Temporary tag paperwork assistance in Philadelphia. We help you prepare the documents needed.",
    },
    {
      key: "replace",
      slug: "tag-replacement-paperwork",
      name: "Tag Replacement Paperwork",
      blurb: "Assistance preparing replacement paperwork for lost, stolen or damaged tags.",
      icon: "Repeat2",
      color: "#0A192F",
      longDescription:
        "Lost, stolen, damaged, or defaced tags? We assist Philadelphia drivers with organizing the replacement application paperwork — reviewed and prepared for submission the same visit.",
      benefits: [
        "Application paperwork prepared same visit",
        "Guidance for lost, stolen, or damaged cases",
        "Full document review before submission",
        "Police reports accepted (not required)",
      ],
      docs: [
        "Current registration (if available)",
        "Police report (if stolen — optional)",
        ...commonDocs,
      ],
      metaDescription:
        "Tag replacement paperwork help in Philadelphia. We assist with the documents needed for replacement applications.",
    },
    {
      key: "custom",
      slug: "custom-plate-applications",
      name: "Custom Plate Applications",
      blurb: "Help applying for personalized, veteran, or specialty designs.",
      icon: "Sparkles",
      color: "#D9B976",
      longDescription:
        "Personalize your ride with a custom Pennsylvania plate application — vanity, organizational, veteran, or specialty designs. We help check availability and prepare your application for submission.",
      benefits: [
        "Availability review before you commit",
        "Personalized, veteran & specialty designs",
        "Application paperwork prepared for you",
        "Guidance on timelines and pricing",
      ],
      docs: [
        "Current registration",
        ...commonDocs,
      ],
      metaDescription:
        "Custom plate application assistance in Philadelphia — vanity, veteran and specialty designs.",
    },
    {
      key: "dup-title",
      slug: "duplicate-title-paperwork",
      name: "Duplicate Title Paperwork",
      blurb: "Help completing the paperwork for a duplicate title application.",
      icon: "Files",
      color: "#C5A059",
      longDescription:
        "Lost, damaged, or destroyed title? We assist with completing MV-38O paperwork and provide in-house notary service. Documents are prepared and reviewed line-by-line before submission.",
      benefits: [
        "Application prepared and reviewed same day",
        "In-house notary included",
        "Tracks paperwork through delivery",
        "Guidance on lien-holder situations",
      ],
      docs: [
        "Photo ID matching the title holder",
        "Any old registration or plate info you have",
        ...commonDocs,
      ],
      metaDescription:
        "Duplicate title paperwork assistance in Philadelphia. We help complete MV-38O documents.",
    },
    {
      key: "reg-card",
      slug: "registration-card-paperwork",
      name: "Registration Card Paperwork",
      blurb: "Help preparing paperwork for a replacement registration card.",
      icon: "CreditCard",
      color: "#0A192F",
      longDescription:
        "Lost or damaged registration card? We help Philadelphia drivers prepare the replacement paperwork on the spot. Great for glove-box mishaps, stolen wallets, or address updates.",
      benefits: [
        "Application prepared same visit",
        "Address update guidance included",
        "No appointment necessary",
        "Bring photo ID and we do the rest",
      ],
      docs: [
        "Photo ID matching the card holder",
        "Plate or VIN if available",
        ...commonDocs,
      ],
      metaDescription:
        "Registration card replacement paperwork assistance in Philadelphia.",
    },
    {
      key: "plates",
      slug: "plate-application-help",
      name: "Plate Application Help",
      blurb: "Assistance with standard, veteran, organization or specialty plate applications.",
      icon: "RectangleHorizontal",
      color: "#B48947",
      longDescription:
        "We help Philadelphia drivers apply for the full range of Pennsylvania plate designs — standard passenger, veteran, organizational, and specialty. Application paperwork is prepared and reviewed at our counter.",
      benefits: [
        "Applications prepared for you",
        "Motorcycle & trailer plates too",
        "Personalized designs available",
        "Full paperwork review",
      ],
      docs: [
        "Signed title or current registration",
        "Proof of insurance",
        ...commonDocs,
      ],
      metaDescription:
        "Plate application assistance in Philadelphia — standard, veteran, specialty designs.",
    },
    {
      key: "notary",
      slug: "notary-public",
      name: "Notary Services",
      blurb: "Certified notary — signatures for titles, POAs, affidavits, contracts.",
      icon: "Stamp",
      color: "#C5A059",
      longDescription:
        "Commissioned Pennsylvania notaries at your service seven days a week. Vehicle titles, powers of attorney, affidavits, business contracts and acknowledgments — signed, sealed, and stamped in under two minutes.",
      benefits: [
        "Commissioned PA notary on-site",
        "Titles, POAs, affidavits, contracts",
        "Walk-ins welcome — no appointment",
        "Weekend and evening hours",
      ],
      docs: [
        "Valid state-issued photo ID for every signer",
        "The unsigned document",
        "All signers present in person",
      ],
      metaDescription:
        "Certified notary public in Philadelphia — titles, POAs, affidavits. Walk-ins welcome.",
    },
    {
      key: "insurance",
      slug: "auto-insurance",
      name: "Auto Insurance",
      blurb: "Compare multiple carriers, bind coverage, print ID cards on the spot.",
      icon: "ShieldCheck",
      color: "#0A192F",
      longDescription:
        "We shop your rate across trusted Pennsylvania insurers — liability, full coverage, SR-22, commercial, rideshare — and bind your policy right at the counter. ID cards printed on the spot so your other paperwork moves smoothly.",
      benefits: [
        "Multi-carrier quotes in minutes",
        "Bind policy and print ID cards same visit",
        "SR-22 and commercial add-ons available",
        "Bundle to save on paperwork day",
      ],
      docs: [
        "Driver's license for every driver",
        "VIN or plate for every vehicle",
        "Prior policy declarations (optional)",
      ],
      metaDescription:
        "Same-day auto insurance in Philadelphia. Compare carriers, bind on-site, print ID cards.",
    },
  ],
  images: {
    hero:
      "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=2400&q=85",
    officeCounter:
      "https://images.pexels.com/photos/3184338/pexels-photo-3184338.jpeg?auto=compress&cs=tinysrgb&w=1600",
    notary:
      "https://images.pexels.com/photos/955395/pexels-photo-955395.jpeg?auto=compress&cs=tinysrgb&w=1600",
    insurance:
      "https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=1600",
    insurancePaperwork:
      "https://images.unsplash.com/photo-1580273916550-e323be2ae537?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=1800&q=85",
    keysDocs:
      "https://images.unsplash.com/photo-1580273916550-e323be2ae537?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=1800&q=85",
    plate:
      "https://images.pexels.com/photos/1149831/pexels-photo-1149831.jpeg?auto=compress&cs=tinysrgb&w=1600",
    office:
      "https://images.pexels.com/photos/3184338/pexels-photo-3184338.jpeg?auto=compress&cs=tinysrgb&w=1600",
    desk:
      "https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=1600",
    handshake:
      "https://images.pexels.com/photos/955395/pexels-photo-955395.jpeg?auto=compress&cs=tinysrgb&w=1600",
    keys:
      "https://images.unsplash.com/photo-1580273916550-e323be2ae537?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=1800&q=85",
    paperwork:
      "https://images.pexels.com/photos/955395/pexels-photo-955395.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  testimonials: [
    {
      quote:
        "Walked in at 6pm on a Saturday and my paperwork was ready in 20 minutes. Nobody else in Philly does this.",
      name: "Marisol V.",
      role: "Bought her first car",
      timeAgo: "2 weeks ago",
      initials: "MV",
      photo: "https://i.pravatar.cc/120?img=48",
    },
    {
      quote:
        "They saved me a full day off work. Title paperwork, tags, insurance — one stop. Prices were straight.",
      name: "Darnell H.",
      role: "Uber Driver",
      timeAgo: "a month ago",
      initials: "DH",
      photo: "https://i.pravatar.cc/120?img=15",
    },
    {
      quote:
        "Notary plus duplicate title paperwork in one visit. Friendly, patient, actually knew the paperwork cold.",
      name: "Anna P.",
      role: "Small business owner",
      timeAgo: "3 weeks ago",
      initials: "AP",
      photo: "https://i.pravatar.cc/120?img=44",
    },
    {
      quote:
        "The staff walked my mother through everything in Spanish. Real people. Real service.",
      name: "Luis R.",
      role: "Family client",
      timeAgo: "5 days ago",
      initials: "LR",
      photo: "https://i.pravatar.cc/120?img=68",
    },
  ],
  whatToBring: {
    universal: [
      "Valid Photo ID or Driver License",
      "Proof of current auto insurance (if applicable)",
      "Payment method (cash, debit, or credit)",
    ],
    scenarios: [
      {
        title: "For title paperwork",
        docs: ["Original Signed Title", "Bill of sale (if private sale)"],
        icon: "FileCheck2",
      },
      {
        title: "For vehicle paperwork",
        docs: ["Signed title or MCO", "Proof of insurance for the vehicle"],
        icon: "CarFront",
      },
      {
        title: "For notary service",
        docs: ["The unsigned document", "All signers present with ID"],
        icon: "Stamp",
      },
      {
        title: "For insurance quotes",
        docs: ["Driver's licenses for all drivers", "VIN or plate for each vehicle"],
        icon: "ShieldCheck",
      },
    ],
  },
  faqs: [
    {
      q: "Do I need an appointment?",
      a: "Walk-ins are welcome any time we're open. Appointments help us prep your paperwork and cut your wait to near-zero.",
    },
    {
      q: "How long does title paperwork take?",
      a: "Most title paperwork is prepared in 15–30 minutes if you bring the signed title, ID, and proof of insurance.",
    },
    {
      q: "Can I get insurance and paperwork done in one visit?",
      a: "Yes. We bind your auto insurance policy on-site and prepare your other paperwork the same day.",
    },
    {
      q: "What forms of payment do you accept?",
      a: "Cash, debit, all major credit cards, Zelle and Cash App. State fees are collected at the counter.",
    },
    {
      q: "Do you speak Spanish, Portuguese or Arabic?",
      a: "Sí. Sim. نعم. Our team is multilingual — English, Spanish, Portuguese and Arabic.",
    },
  ],
};

export const getServiceBySlug = (slug) =>
  SITE.services.find((s) => s.slug === slug);
